import dayjs from 'dayjs';

export default function formatDate(value: string, format: string) {
  if (!format) {
    format = 'DD/MM/YY';
  } else {
    switch (format) {
      case 'datetime': {
        format = 'DD/MM/YY [às] HH:mm';

        break;
      }

      case 'slim': {
        format = 'DD MMM, HH:mm';

        break;
      }

      case 'age': {
        return value && dayjs(value).startOf('year').fromNow(true);
      }

      case 'fromNow': {
        const date = value && dayjs(value);

        return date && date.fromNow();
      }

      case 'duration': {
        return value && dayjs.duration(value).humanize();
      }

      case 'longtime': {
        format = 'DD MMM YY [às] HH:mm';

        break;
      }

      case 'longerDate': {
        format = 'DD MMM YYYY';

        return dayjs(String(value)).format(format).toLowerCase();
      }
      // No default
    }
  }

  if (value) {
    return dayjs(value).format(format);
  }
}
